import { Component, Vue } from 'vue-property-decorator'
import { createTechnologyTa, getStudentListByCourseType, getTechnologyTaList, editRemark } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
import urlBase from '@/utils/urlBase'
import axios from 'axios'
axios.defaults.withCredentials = true

@Component({ name: 'student-list-page', components: { HighFilter } })
export default class StudentListPage extends Vue {
  private dataType = 1
  private tableData = []
  private totalPage = 1;
  private currentPage = 1;
  private filterData: any = {};
  private filterResult: any = null
  private showHighFilter = false
  private technologyTaSelectDialogShow: any = false
  private technologyTaList: any = []
  private technologyTaChoose: any = ''
  private classId: any =''
  private tableloading: any = false
  private exportDialog: any = false
  private exportRadio: any = '1'
  private exportTime: any = null
  created () {
    this.initPageData()
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('教研总监') > -1)) {
      this.echnologyTaList()
    }
  }

  get inclass () {
    return this.getinclass()
  }

  getinclass () {
    return this.tableData.filter((item: any) => { return item.status === 2 })
  }

  private async initPageData () {
    // 按钮list【】
    // 修改备注 匹配科研助教
    const list: any = [{ path: '/sellOrder/edit/remark', pathName: 'editRemark' }, { pathName: 'createTechnologyTa', path: '/class/relation/create/technologyTa' }]
    this.tableloading = true
    const param: any = { courseType: this.dataType, page: this.currentPage, limit: 20 }
    param.pathList = list
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await getStudentListByCourseType(param)
    this.currentPage = result.currentPage
    this.totalPage = result.allPage
    this.tableData = result.studentList
    this.filterData = result.search
    this.tableloading = false
  }

  // type 切换回调函数
  private async onTypeChange (type: any) {
    if (!this.tableloading) {
      this.dataType = type
      this.currentPage = 1
      this.filterResult = null
      this.initPageData()
    }
  }

  private async onPageChange (page: any) {
    this.currentPage = page
    this.initPageData()
  }

  private statusFormat (status: any) {
    //  1，未上课；2，上课中；3，已结课；4，异常中；5，换项目中；6，换导师中
    const str = ['', '未上课', '上课中', '已结课', '异常中', '换项目中', '换导师中']
    return str[status]
  }

  private rowClicked (row: any, column: any, cell: any, event: any) {
    this.$router.push({ path: '/student/detail', query: { id: row.studentId, detailType: '1' } })
  }

  private async echnologyTaList () {
    const list = await getTechnologyTaList({})
    this.technologyTaList = list
  }

  private async onSetClick () {
    const { error }: any = await createTechnologyTa({ classId: this.classId, technologyId: this.technologyTaChoose })
    if (!error) {
      this.$message({ type: 'success', message: '分配科研助教成功' })
      this.initPageData()
    }
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }

  private async changeRemark (item: any) {
    const { error }: any = await editRemark({ sellOrderId: item.sellOrderId, remark: item.remark })
    if (!error) {
      this.$message({ type: 'success', message: '修改备注成功' })
      await this.initPageData()
    }
  }

  private async exportList () {
    // downloadTemplate
    const name = null
    let url = null
    if (this.exportRadio === '1') {
      // url = 'http://192.168.0.33:10069/student/export?courseType=' + this.dataType
      url = urlBase.eduBaseUrl + 'student/export?courseType=' + this.dataType
    } else {
      // url = 'http://192.168.0.33:10069/student/export?startTime=' + this.exportTime[0] + '&endTime=' + this.exportTime[1] + '&courseType=' + this.dataType
      url = urlBase.eduBaseUrl + 'student/export?startTime=' + this.exportTime[0] + '&endTime=' + this.exportTime[1] + '&courseType=' + this.dataType
    }
    const a: any = document.createElement('a')
    a.href = url
    a.click()
    this.exportTime = null
    this.$message({ message: '导出成功', type: 'success' })
    this.exportDialog = false
  }

  // 导出优化
  // private async exportList1 () {
  //   this.tableloading = true
  //   const param: any = { courseType: this.dataType * 1 }
  //   if ((this.exportRadio * 1) !== 1) {
  //     param.startTime = this.exportTime[0]
  //     param.endTim = this.exportTime[1]
  //   }
  //   if (this.filterResult) {
  //     param.search = this.filterResult
  //   }
  //   const url = urlBase.eduBaseUrl + 'student/export'
  //   axios.defaults.headers = {
  //     'Content-Type': 'application/json' // 这儿是通过json格式 传值，如果需要通过formData形式，可以改，详情 https://www.cnblogs.com/honkerzh/p/14157038.html
  //   }
  //   axios({ // 用axios发送post请求
  //     method: 'post',
  //     url: url, // 请求地址
  //     data: param, // 参数
  //     responseType: 'blob' // 表明返回服务器返回的数据类型
  //   })
  //     .then((res: any) => { // 处理返回的文件流
  //       const blob = new Blob([res.data], {
  //         type: 'application/vnd.ms-excel'
  //       }) // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
  //       const url = window.URL.createObjectURL(blob) // 3.创建一个临时的url指向blob对象
  //       // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
  //       const a = document.createElement('a')
  //       a.href = url
  //       // a.download = '学生表格.xlsx'
  //       a.click()
  //       window.URL.revokeObjectURL(url)
  //     })
  //   this.exportTime = null
  //   this.$message({ message: '导出成功', type: 'success' })
  //   this.exportDialog = false
  //   this.tableloading = false
  // }
}
